<template>
  <div class="form-group form-inline">
    <label for="timeInput">Server-Zeit</label>
    <input id="timeInput"
           type="datetime-local"
           class="form-control ms-1"
           v-model="time">
    <button class="btn btn-sakali ms-1"
            @click="save">
      Setzen
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: undefined
    }
  },
  methods: {
    save() {
      this.$api.post('/admin/time', {'time': this.time}).then(response => {
        this.time = response.data
        this.showMessage({
          message: 'Zeit geändert',
          type: 'info'
        })
      })
    }
  },
  mounted() {
    this.$api.get('/admin/time').then(response => {
          this.time = response.data
        }
    )
  }
}
</script>